import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default class AButton extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isActive: false,
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleClick = this.handleClick.bind(this);
		this.handleClickForSend = this.handleClickForSend.bind(this);
	}

	handleClick() {
		if (this.props.onClick) {
			this.props.onClick();
		}

		this.setState(prev => ({ isActive: !prev.isActive }));

		this.handleClickForSend();
	}

	handleClickForSend() {
		if (this.props.type !== 'send') {
			return;
		}

		setTimeout(() => {
			this.setState({ isActive: false });
		}, 2400);
	}

	render() {
		let cName = this.props.className;

		switch (this.props.type) {
			case 'ghost':
				cName = `a-button--ghost ${cName}`;
				break;
			case 'destructive':
				cName = `a-button--default a-button--destructive ${cName}`;
				break;
			case 'send':
				cName = `a-button--default a-button--send ${cName}`;
				break;
			default:
				cName = `a-button--default ${cName}`;
				break;
		}

		return (
			<button
				type="button"
				className={`a-button ${cName} ${this.state.isActive ? 'active' : ''}`}
				onClick={this.handleClick}
				disabled={this.props.disabled}
			>
				<FormattedMessage id={this.props.value} defaultMessage="" />
			</button>
		);
	}
}

AButton.propTypes = {
	value: PropTypes.string,
	type: PropTypes.string,
	disabled: PropTypes.bool,
	className: PropTypes.string,
	onClick: PropTypes.func,
};

AButton.defaultProps = {
	value: '',
	type: '',
	disabled: false,
	className: '',
	onClick: null,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.button.js